import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-new-project-status',
  templateUrl: './new-project-status.component.html',
  styleUrls: ['./new-project-status.component.scss'],
})
export class NewProjectStatusComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  projectStatusData: any;
  projectStatusAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  materialList: any;
  selectOrganization: any;
  organizationlist: any;
  activeCheckbox = false;
  isDisableDropDown!: boolean;
  @Output() saveNewProjectStatusEvent = new EventEmitter<any>();

  constructor(private formBuilder: FormBuilder, private modal: CustomModalService) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.projectStatusData =
      this.modal?.modalService?.config?.initialState?.['newProjectStatusData'];
    const placeHolderOrganization = {
      name: 'All organization',
    };
    const newOrganizationlist = [placeHolderOrganization].concat(
      this.projectStatusData.organization || this.projectStatusData.organizationItems
    );
    this.activeCheckbox = this.projectStatusData.ispublic || this.projectStatusData.isPublic;
    this.organizationlist = newOrganizationlist;
    this.organizatioListFunction();
  }

  ngOnInit(): void {
    this.projectStatusAddEditForm = this.formBuilder.group({
      organizationName: [this.projectStatusData.organizationId || this.organizationlist[0] || null],
      lableName: [this.projectStatusData.label || '', Validators.required],
      position: [this.projectStatusData.position || '', Validators.required],
      isPublic: [false],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.projectStatusData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  setFormData() {
    this.projectStatusAddEditForm.patchValue({ organizationName: this.selectOrganization });
  }

  onSave() {
    this.submitted = true;
    if (this.projectStatusAddEditForm.invalid) {
      return;
    }
    if (this.activatedRoute == 'scenario-status') {
      const saveScenarioStatusData = {
        scenarioStatusId: this.projectStatusData.scenarioStatusId || 0,
        isPublic: this.projectStatusAddEditForm.controls['isPublic'].value,
        label: this.projectStatusAddEditForm.controls['lableName'].value,
        position: this.projectStatusAddEditForm.controls['position'].value,
        organizationId:
          this.projectStatusAddEditForm.controls['organizationName'].value?.name ==
            'All organization' ||
          this.projectStatusAddEditForm.controls['organizationName'].value?.name == undefined
            ? null
            : this.projectStatusAddEditForm.controls['organizationName'].value?.id,
      };
      this.saveNewProjectStatusEvent.emit({
        payload: saveScenarioStatusData,
        pathName: this.activatedRoute,
      });
    } else {
      const saveprojectStatusData = {
        statusId: this.projectStatusData.statusId || 0,
        ispublic: this.projectStatusAddEditForm.controls['isPublic'].value,
        label: this.projectStatusAddEditForm.controls['lableName'].value,
        position: this.projectStatusAddEditForm.controls['position'].value,
        organizationId:
          this.projectStatusAddEditForm.controls['organizationName'].value?.name ==
            'All organization' ||
          this.projectStatusAddEditForm.controls['organizationName'].value?.name == undefined
            ? null
            : this.projectStatusAddEditForm.controls['organizationName'].value?.id,
      };
      this.saveNewProjectStatusEvent.emit({
        payload: saveprojectStatusData,
        pathName: this.activatedRoute,
      });
    }
  }
}
